export default function hasProductPermission(permission: string, permissions: Array<string>) {
  for (let i = 0; i < permissions.length; i++) {
    if (permissions[i] === permission) {
      return true;
    }
  }
  return false;
}
